// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import $ from 'jquery';
import axios from 'axios';
import store from './store';
import iView from 'iview';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import './theme/index.less';
import './styles/common.less';
import * as echarts from 'echarts';
// import Clipboard from 'clipboard';


Vue.config.productionTip = false;
// Vue.prototype.clipboard = Clipboard;
axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.use(iView);
Vue.use(ElementUI)
Vue.use(VueI18n);
// Vue.use(QRCode)
Vue.prototype.$echarts = echarts;
Vue.prototype.$ajax=axios;


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    mounted() {
        this.$store.commit('setMenuList');
    }
})
